import React, { useEffect, useState } from "react";
import Lenis from "lenis";
import CustomCursor from "../components/CustomCursor";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Founder from "../components/Founder";
import ChitraSpotlight from "../components/ChitraSpotlight";
import PawanSpotlight from "../components/PawanSpotlight";
import StudioScene from "../components/StudioScene";
import OurWorksShowcase from "../components/OurWorksShowcase";
import ClientFeedbackShowcase from "../components/ClientFeedbackShowcase";
import Portfolio from "../components/Portfolio";
import Process from "../components/Process";
import Stats from "../components/Stats";
import Testimonials from "../components/Testimonials";
import Security from "../components/Security";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import ScrollToTop from "../components/ScrollToTop";
import FAQ from "../components/FAQ";
import Technologies from "../components/Technologies";
import PlaneGame from "../components/PlaneGame";
import SEO from "../components/SEO";
import SectionStepper from "../components/SectionStepper";

const Landing = () => {
  const [loading, setLoading] = useState(true);

  // Smooth scroll with Lenis
  useEffect(() => {
    if (loading) return;
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.4
    });

    // Patch scrollIntoView to use lenis for anchor clicks
    const onAnchorClick = (e) => {
      const target = e.target.closest('a[href^="#"], a[href^="/#"]');
      if (!target) return;
      let id = target.getAttribute("href");
      if (id.startsWith("/#")) id = id.substring(1);
      if (id && id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: 0, duration: 1.4 });
        }
      }
    };
    document.addEventListener("click", onAnchorClick);

    let raf;
    const tick = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);

    // Scroll to hash on load if present
    if (window.location.hash) {
      setTimeout(() => {
        const el = document.querySelector(window.location.hash);
        if (el) lenis.scrollTo(el, { offset: 0, duration: 1.4 });
      }, 500);
    }

    window.lenis = lenis;
    return () => {
      document.removeEventListener("click", onAnchorClick);
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.lenis = null;
    };
  }, [loading]);

  // Remove Elfsight Branding link via MutationObserver for robust removal
  useEffect(() => {
    if (loading) return;

    const removeBranding = () => {
      const elfsightLink = document.querySelector('a[href*="elfsight.com"]');
      if (elfsightLink) {
        elfsightLink.remove();
      }
    };

    // Initial check
    removeBranding();

    // Create an observer instance linked to the document body
    const observer = new MutationObserver((mutations) => {
      removeBranding();
    });

    // Start observing the target node for configured mutations
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    return () => observer.disconnect();
  }, [loading]);

  return (
    <>
      <SEO
        title="Home"
        description="Meraki Solutions — A multidisciplinary creative studio blending storytelling, branding, media, and digital innovation to build work that resonates. At Meraki Solutions, we believe the strongest brands are built through clarity, emotion, and experience."
      />
      <Loader onDone={() => setLoading(false)} />
      {/* <CustomCursor /> */}
      <div className="grain" />
      <Navbar />
      <main>
        <SectionStepper
          sections={[
            { id: "top", label: "Intro" },
            { id: "services", label: "Expertise" },
            { id: "founder", label: "The Soul" },
            { id: "portfolio", label: "Work" },
            { id: "showcase", label: "Our Works" },
            { id: "feedback", label: "Success Vlogs" },
            { id: "process", label: "Journey" },
            { id: "social", label: "Social" },
            { id: "testimonials", label: "Stories" },
            { id: "faq", label: "FAQ" }
          ]}
        />
        <Hero />
        <Services />
        <Founder />
        <ChitraSpotlight />
        <PawanSpotlight />
        {/* <StudioScene /> */}
        <Portfolio />
        <Technologies />
        {/* <Security /> */}
        <OurWorksShowcase />
        <ClientFeedbackShowcase />
        <Process />
        <Stats />

        {/* Instagram Feed Section */}
        <section id="social" className="py-24 relative overflow-hidden bg-[var(--ink)]">
          <div className="container-xl px-6">
            <div className="flex items-center gap-4 mb-12">
              <span className="font-impact text-[11px] tracking-[0.4em] text-[var(--gold)]">08</span>
              <span className="w-16 h-px bg-[var(--rule)]" />
              <span className="font-impact text-[11px] tracking-[0.4em] text-[var(--cream-muted)] uppercase">Instagram Stories</span>
            </div>
            <div className="elfsight-app-87cfcec8-a9d2-45a4-87e9-f961b03c2016 instagram-feed-container" data-elfsight-app-lazy></div>
          </div>
        </section>

        <Testimonials />
        <PlaneGame />
        <FAQ />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
};

export default Landing;
